import React from "react";
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";

import AboutClassplus from "../Desktopscreens/aboutClassplus";
import Header from "../Desktopscreens/components/Header";
import Homepage from "../Desktopscreens/homePage";
import AboutAnantLadha from "../Desktopscreens/aboutAnantLadha";
import ContactUs from "../Desktopscreens/contactUs";
import Footer from "../Desktopscreens/components/Footer";

const DestopView = () => {
  return (
    <div className="desktop-view">
      <BrowserRouter basename="/Finclave2022">
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />

          <Route path="/aboutClp" element={<AboutClassplus />} />

          <Route path="/aboutAnant" element={<AboutAnantLadha />} />

          <Route path="/contactUs" element={<ContactUs />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default DestopView;
